import { loadScript } from 'dashboard/helper/DOMHelpers';

const FACEBOOK_SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
const FACEBOOK_SDK_LOAD_TIMEOUT = 15000;

const waitForFacebookSdk = () =>
  new Promise((resolve, reject) => {
    const timeoutId = window.setTimeout(() => {
      reject(
        new Error('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.SDK_LOAD_ERROR')
      );
    }, FACEBOOK_SDK_LOAD_TIMEOUT);

    const checkSdk = () => {
      if (window.FB) {
        window.clearTimeout(timeoutId);
        resolve(window.FB);
        return;
      }

      window.setTimeout(checkSdk, 50);
    };

    checkSdk();
  });

export const loadFacebookSdk = async () => {
  // The SDK can already have been injected by another Meta integration on the
  // dashboard. In that case its `load` event has already fired, so waiting on
  // the existing script element would leave embedded signup pending forever.
  if (window.FB) return window.FB;

  await loadScript(`${FACEBOOK_SDK_URL}?lumeratec=${Date.now()}`, {
    async: true,
    defer: true,
    crossOrigin: 'anonymous',
  });

  return waitForFacebookSdk();
};

export const initializeFacebook = (appId, apiVersion) => {
  if (!window.FB) {
    return Promise.reject(
      new Error('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.SDK_INIT_ERROR')
    );
  }

  window.FB.init({
    appId,
    autoLogAppEvents: true,
    xfbml: true,
    version: apiVersion || 'v25.0',
  });

  return Promise.resolve();
};

export const isValidBusinessData = businessData => {
  return businessData && businessData.business_id && businessData.waba_id;
};

export const createMessageHandler = onEmbeddedSignupData => {
  return event => {
    if (!/^https:\/\/(?:[a-z0-9-]+\.)*facebook\.com$/i.test(event.origin))
      return;

    try {
      let data;
      if (typeof event.data === 'string') {
        data = JSON.parse(event.data);
      } else if (typeof event.data === 'object' && event.data !== null) {
        data = event.data;
      } else {
        return;
      }

      if (data.type === 'WA_EMBEDDED_SIGNUP') {
        onEmbeddedSignupData(data);
      }
    } catch {
      // Ignore non-JSON or irrelevant messages
    }
  };
};

export const initWhatsAppEmbeddedSignup = configId => {
  return new Promise((resolve, reject) => {
    window.FB.login(
      response => {
        if (response.authResponse && response.authResponse.code) {
          resolve(response.authResponse.code);
        } else if (response.error) {
          reject(new Error(response.error));
        } else {
          reject(new Error('Login cancelled'));
        }
      },
      {
        config_id: configId,
        response_type: 'code',
        override_default_response_type: true,
        extras: {
          setup: {},
          featureType: 'whatsapp_business_app_onboarding',
          sessionInfoVersion: '3',
        },
      }
    );
  });
};

export const setupFacebookSdk = async (appId, apiVersion) => {
  const version = apiVersion || 'v22.0';
  await loadFacebookSdk();
  await initializeFacebook(appId, version);
};
